module.exports = __webpack_public_path__ + "static/media/device.b54df648.svg";